import { render, staticRenderFns } from "./ViewRegistrationPage.vue?vue&type=template&id=c7e319f2&"
import script from "./ViewRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./ViewRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports